import { Td, Tr, Text } from "@chakra-ui/react";
import { flexRender } from "@tanstack/react-table";
import type { RowProps } from "./Row.d";

const Row = ({ row, isLast }: RowProps) => (
  <Tr key={row.id} role="row">
    {row.getVisibleCells().map((cell) => (
      <Td key={cell.id} pl={4} _first={{ border: "none", p: 0, textAlign: "center" }} border={isLast && "none"}>
        <Text as="span" fontSize="sm">
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </Text>
      </Td>
    ))}
  </Tr>
);

export default Row;
